<div
  class="component-theme"
  [class.theme-dark]="effectiveTheme() === 'dark'"
  [class.theme-light]="effectiveTheme() !== 'dark'"
>
  <!-- Optional building cards -->
  <div class="content-margin document-list buildings-list" [formGroup]="homeForm" id="bldgs">
    <!-- *ngIf="selectedBuilding" -->
    <mat-card *ngFor="let sb of (buildingsByLoggedUser$ | async) ?? []" class="buildingCard">
      <mat-card-header>
        <mat-card-title>{{ sb?.name }}</mat-card-title>
        <mat-card-subtitle>{{ sb?.address }}, {{ sb?.city }}, {{ sb?.postalCode }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <!--  <div *ngFor="let f of sb?.floors">
                <div *ngFor="let test of f.floorPlans">
                    <p>{{test.fileName}}</p>
                </div>
                
            </div> -->
        <div class="ddl-file">
          <mat-form-field>
            <mat-label class="select-label" id="{{ 'floorPlanLabel_' + sb?.id }}">Floor plan</mat-label>
            <mat-select
              aria-labelledby="{{ 'floorPlanLabel_' + sb?.id }}"
              [formControl]="buildingFpFormControl"
              (selectionChange)="floorPlanClicked($event.value)"
            >
              <mat-option *ngFor="let fp of buildingFloorPlans[sb?.id]" [value]="fp">
                <a [attr.id]="fp?.url" [href]="fp?.url" target="_blank" class="hide">{{ fp?.name }}</a>
                <a [href]="">{{ fp?.name }}</a>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="ddl-file">
          <mat-form-field>
            <mat-label class="select-label" id="{{ 'bpLabel_' + sb?.id }}">Building Procedure</mat-label>
            <mat-select
              aria-labelledby="{{ 'bpLabel_' + sb?.id }}"
              [formControl]="buildingBpFormControl"
              (selectionChange)="buildingProcedureClicked($event.value)"
            >
              <mat-option *ngFor="let bp of sb?.buildingProcedures" [value]="bp">
                <a
                  [attr.id]="bp?.buildingProcedureUrl"
                  [href]="bp?.buildingProcedureUrl"
                  target="_blank"
                  class="hide"
                  >{{ bp?.fileName }}</a
                >
                <a [href]="">{{ bp?.fileName }}</a>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-divider></mat-divider>
      </mat-card-content>
      <mat-card-actions>
        <mat-icon
          *ngFor="let amenity of sb?.amenities"
          [matTooltip]="amenity?.buildingAmenity?.description"
          aria-hidden="false"
          [attr.aria-label]="amenity?.buildingAmenity?.description"
        >
          {{ amenity?.buildingAmenity?.iconName }}
        </mat-icon>
      </mat-card-actions>
    </mat-card>
  </div>

  <div class="book-workspace-header content-margin">
    <h1 class="ewrs-page-title">Book a workspace</h1>
    <button id="show" type="button" class="display-buildings-link" (click)="show()">Display buildings</button>
  </div>

  <!-- Reservation search -->
  <app-search-bar
    [bookingForOptions]="(bookingForOptions$ | async) ?? []"
    [bookingForSearchControl]="userSearchControl"
    [locations]="(locationOptions$ | async) ?? []"
    [floors]="(floorOptions$ | async) ?? []"
    [timePeriods]="(timePeriodOptions$ | async) ?? []"
    [selectedBookingForId]="selectedBookingForId"
    [selectedBookingForLabel]="selectedBookingForLabel"
    [bookingForSelfOptionLabel]="bookingForSelfOptionLabel"
    [bookingForNoEntriesLabel]="noResultsLabel"
    [selectedLocationId]="selectedLocationId"
    [selectedFloorIds]="selectedFloorIdsForSearchBar"
    [selectedPeriodId]="selectedPeriodIdForSearchBar"
    [selectedStartDate]="selectedStartDateForSearchBar"
    [selectedEndDate]="selectedEndDateForSearchBar"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [autofillInProgress]="isAutofillInProgress"
    [repeatDisabled]="isRepeatDisable"
    [repeatEnabled]="isRepeat"
    (bookingForChanged)="onBookingForChange($event)"
    (locationChanged)="onLocationChange($event)"
    (floorSelectionChanged)="onFloorSelectionChange($event)"
    (repeatEnabledChanged)="onRepeatEnabledChanged($event)"
    (selectedDaysChanged)="onSelectedDaysChanged($event)"
    (periodChanged)="onPeriodChanged($event)"
    (startDateChanged)="onFiltersChanged($event)"
    (endDateChanged)="onEndDateChanged($event)"
    (filtersChanged)="onFiltersChanged($event)"
    (searchRequested)="onSearchRequested($event)"
  ></app-search-bar>

  <!-- Workstation results -->
  <div class="searchResultsTable content-margin" #resultsSection>
    <!-- Search result filter chips for desk amenities -->
    <div *ngIf="amenityFilters.length > 0" class="amenity-filter">
      <span class="amenity-filter-heading" id="amenity-filter-heading">Filter by amenity</span>
      <div class="amenity-chip-row" role="group" aria-labelledby="amenity-filter-heading">
        <app-chip
          *ngFor="let amenity of amenityFilters"
          [label]="amenity.label"
          [iconName]="amenity.iconName"
          [svgIconName]="amenity.svgIconName || ''"
          [isSelected]="isAmenitySelected(amenity.id)"
          (selectedChange)="onAmenityChipToggle(amenity.id, $event)"
        ></app-chip>
      </div>
    </div>

    <!-- Result count and desk name search -->
    <div *ngIf="showResultsToolbar" class="results-toolbar">
      <p #resultsHeading tabindex="-1" class="results-count" aria-live="polite">
        {{ (dataSource?.dataCount$ | async) ?? 0 }} desk{{ ((dataSource?.dataCount$ | async) ?? 0) === 1 ? '' : 's' }}
        available
      </p>
      <app-ods-input
        class="desk-search-input"
        [labelText]="''"
        [labelFor]="'deskSearchInput'"
        [labelId]="'deskSearchLabel'"
      >
        <mat-form-field appearance="outline">
          <mat-icon matPrefix fontSet="material-symbols-outlined" aria-hidden="true">search</mat-icon>
          <input
            #deskSearchInput
            matInput
            id="deskSearchInput"
            type="text"
            [formControl]="deskSearchControl"
            placeholder="Search by desk number"
            aria-label="Search by desk number"
            autocomplete="off"
            (keydown.escape)="clearDeskSearch()"
          />
          <button
            *ngIf="hasDeskSearchText"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Clear desk search"
            (click)="clearDeskSearch()"
          >
            <mat-icon fontSet="material-symbols-outlined" aria-hidden="true">close</mat-icon>
          </button>
        </mat-form-field>
      </app-ods-input>
    </div>

    <div *ngIf="showNoWorkstationsState" class="no-workstations">
      <img
        [src]="
          effectiveTheme() === 'dark'
            ? 'assets/ontario-design-system/icons/svg/ontario-icon-search-results-dark.svg'
            : 'assets/ontario-design-system/icons/svg/ontario-icon-search-results.svg'
        "
        class="no-workstations-icon"
        alt=""
        aria-hidden="true"
      />
      <ng-container *ngIf="hasDeskSearchText && dataSource?.hasUnfilteredResults; else noDesksAvailable">
        <h2 class="ewrs-section-title" #resultsHeading tabindex="-1">No matching desks found.</h2>
        <p>Check the desk number or try adjusting your filters to find available desks that match your needs.</p>
      </ng-container>
      <ng-template #noDesksAvailable>
        <h2 class="ewrs-section-title" #resultsHeading tabindex="-1">No desks available</h2>
        <p>Try adjusting your filters to find available desks that match your needs.</p>
      </ng-template>
    </div>
    <div [ngClass]="{ 'hide-table': ((dataSource.dataCount$ | async) ?? 0) === 0 }">
      <!-- Notice: user has favourites saved but none are available for this search -->
      <div *ngIf="allFavouritesUnavailable" class="favourites-unavailable-notice">
        <img src="assets/images/ontario-icon-alert-warning.svg" class="favourites-heading-icon" aria-hidden="true" />
        <span>
          None of your favourite desks match your current search criteria. Showing all other available desks below.
        </span>
      </div>

      <!-- Workstation availability table (favourites pinned to top, then desk number order) -->
      <app-table
        [dataSource]="dataSource"
        [columns]="resultsTableColumns"
        [length]="(dataSource.dataCount$ | async) ?? 0"
        [pageIndex]="tablePageIndex"
        [pageSize]="tablePageSize"
        [pageSizeOptions]="[10, 20, 50]"
        [showRangeSummary]="true"
        [resultNoun]="'results'"
        [rowHeight]="80"
        [headerRowHeight]="44"
        (pageChanged)="onResultsPageChanged($event)"
        (favouriteToggle)="onResultsFavouriteToggle($event)"
        (actionButtonClick)="onResultsActionButtonClick($event)"
      ></app-table>
    </div>
  </div>
</div>
